@if (isLoading()) {
<div class="spinner-container">
    <div class="spinner-background">
        <mat-spinner />
    </div>
</div>
}
@if (!isLoading()) {
<div class="col p-0">
    <div class="row">
        <div class="d-flex flex-column">
            <p-dataview [value]="visibleTools()" [layout]="layout()" [paginator]="visibleTools().length > 0" [rows]="rows"
                [totalRecords]="totalRecords()" [first]="first()" [lazy]="true" (onPage)="onPageChange($event)">
                <ng-template #emptymessage>
                    <div class="d-flex align-items-center justify-content-center text-center" style="min-height: 50vh;">
                        <h2>
                            no results found
                        </h2>
                    </div>
                </ng-template>

                <!-- Data View Header -->
                <ng-template #header>
                    <div class="d-flex flex-column flex-md-row align-items-center gap-2">
                        <div class="flex-grow-1">
                            <ng-content select="[slot=search]" />
                        </div>
                        @if (isAdmin()) {
                            <button class="button add-button" type="button" (click)="openCreateToolDialog()">
                                add tool
                                <span class="material-symbols-outlined">add</span>
                            </button>
                        }
                        <div class="ms-auto">
                            <p-select-button [ngModel]="layout()" (ngModelChange)="onLayoutChange($event)" [options]="options" [allowEmpty]="false">
                                <ng-template #item let-option>
                                    <span class="material-symbols-outlined">
                                        {{ option === 'list' ? 'view_list' : 'grid_view' }}
                                    </span>
                                </ng-template>
                            </p-select-button>
                            
                        </div>
                    </div>
                </ng-template>

                @if (this.visibleTools().length > 0) {
                <!-- Grid Layout -->
                <ng-template #grid let-items>
                    <div class="row g-3">
                        @for (item of items; track $index) {
                        <div class="col-12 col-sm-6 col-lg-4">
                            <div class="card" 
                                (click)="openModalDialog(item)"
                                ngbTooltip="click for details"
                                container="body">
                                <div class="card-content">
                                    <div class="grid-img">
                                        @if(item.imageUrl) {
                                            <img [attr.loading]="'lazy'"
                                                [src]="item.imageUrl | secure | async"
                                                (load)="onImageLoad($index)"
                                                (error)="onImageError($index)" />
                                            @if(!imageLoaded()[$index]) {
                                                <p-skeleton width="100%" height="100%" />
                                            }
                                        }
                                    </div>
                                    <h6>{{item.name}}</h6>
                                    @if (isAdmin() && item.status === 'Draft') {
                                        <div class="small text-muted">Draft</div>
                                    }
                                    @if (!item.shortDescription) {
                                        <p>{{item.name}}</p>
                                    }
                                    @if (item.shortDescription) {
                                        <p class="description">{{item.shortDescription}}</p>
                                    }
                                    @if (isAdmin()) {
                                        <div class="button-container">
                                            <button class="button small" type="button" (click)="$event.stopPropagation(); openEditToolDialog(item.id)">
                                                <span class="material-symbols-outlined">edit</span>
                                            </button>
                                            <button class="button small btn-danger" (click)="$event.stopPropagation(); onDeleteTool(item.id)">
                                                <span class="material-symbols-outlined">delete</span>
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </ng-template>

                <!-- List Layout -->
                <ng-template #list let-items>
                    <div class="list-container">
                        @for (item of items; track $index) {
                        <div class="row align-items-center list-item" 
                            [class.border-top]="$index !== 0" 
                            (click)="openModalDialog(item)" 
                            ngbTooltip="click for details"
                            container="body">
                            <div class="col-2 col-md-2">
                                @if(item.imageUrl) {
                                    <div class="list-image">
                                        <img class="d-block w-100" [attr.loading]="'lazy'"
                                            [src]="item.imageUrl | secure | async"
                                            (load)="onImageLoad($index)"
                                            (error)="onImageError($index)" />
                                        @if(!imageLoaded()[$index]) {
                                            <p-skeleton width="100px" height="60px" />
                                        }
                                    </div>
                                }
                            </div>
                            <div class="col-8 col-md-8 align-self-start">
                                <div class="d-flex flex-column list-content">
                                    <div class="h6 list-title">{{item.name}}
                                        @if (isAdmin() && item.status === 'Draft') {
                                            <span class="ms-2 small text-muted">(Draft)</span>
                                        }
                                    </div>
                                    <div class="list-description">{{ item.shortDescription }}</div>
                                </div>
                            </div>
                            <div class="col-2 col-md-2">
                                <div class="button-container">
                                    @if (isAdmin()) {
                                        <button class="button small" type="button" (click)="$event.stopPropagation(); openEditToolDialog(item.id)">
                                            <span class="material-symbols-outlined">edit</span>
                                        </button>
                                        <button class="button small btn-danger" (click)="$event.stopPropagation(); onDeleteTool(item.id)">
                                            <span class="material-symbols-outlined">delete</span>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </ng-template>
                }
            </p-dataview>
        </div>
    </div>
</div>
}